document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', function (e) {
    const checkoutBtn = e.target.closest('#checkout-submit');

    if (!checkoutBtn) return;

    // Prevent immediate checkout
    e.preventDefault();

    try {
      const errors = [];
      // Get cart via AJAX - this is internal with Shopify - not part of our theme files
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          if (cart && cart.items && cart.items.length > 0) {
            for (const item of cart.items) {
              const deliveryDate = item.properties?.Bezorgdatum; // Delivery Date
              const pickupDate = item.properties?.Ophaaldatum; // Pick-up Date

              // If dates are not provided, cancel the checkout
              if (!deliveryDate || !pickupDate) {
                errors.push(`${item.product_title} - Missing dates for ${item.title}`);
                break;
              }

              const deliveryDateValue = parseDateField(deliveryDate);
              const pickupDateValue = parseDateField(pickupDate);

              const now = new Date();
              const currentHour = now.getHours();
              if (currentHour >= 16 && (isTomorrow(deliveryDateValue) || isTomorrow(pickupDateValue))) {
                errors.push(`${item.product_title} - the next day delivery is disabled when it's past 4PM`);
                break;
              }

              if (isPastOrToday(deliveryDateValue)) {
                errors.push(`${item.product_title} - Start date for ${item.title} has passed.`);
                break;
              }
              if (pickupDateValue < deliveryDateValue) {
                errors.push(`${item.product_title} - End date must be after start date for ${item.title}.`);
                break;
              }
            }
          }

          // Stops checkout process if errors are found
          if (errors.length > 0) {
            const checkoutErrorContainer = document.getElementById('checkout-failure-message-container');
            if (checkoutErrorContainer) {
              checkoutErrorContainer.style.display = 'block';
            }

            console.error('[Shopify] Cart error', errors);
            return;
          }

          window.location.href = '/checkout';
        });
    } catch (err) {
      console.error('[Shopify] Cart error:', err);
    }
  });
});

/**
 * Parse date string value to be a Date object
 * @param dateStr
 * @returns {Date}
 */
function parseDateField(dateStr) {
  const [day, month, year] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Check date if the value is equal today or a past date
 * @param date
 * @returns {boolean}
 */
function isPastOrToday(date) {
  const now = new Date();
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return d <= today; // true if date is today or earlier
}

/**
 * Check if the given date is in the past or tomorrow
 * @param {Date} date
 * @returns {boolean}
 */
function isTomorrow(date) {
  const input = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

  return input.getTime() === tomorrow.getTime();
}